var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3840,
    height: 3840,
    viewBox: "0 0 3840 3840",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(1324 7802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(-1324 -7802)",
    fill: "#02a1ff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1920,
    cy: 1920,
    r: 1920,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1920,
    cy: 1920,
    r: 1919.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2",
    transform: "translate(-264.026 -6989.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(86.84 24.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M804.458,1720.6a578.5,578.5,0,0,0,227.431-31.262,120.22,120.22,0,0,0,68.094-121.644,148.15,148.15,0,0,0-85.8-123A1650.832,1650.832,0,0,0,751.345,1325.08c-91.928-33.977-175-67.956-249.221-105.332A732.7,732.7,0,0,1,310.1,1087.231,543.555,543.555,0,0,1,188.895,905.1,678.269,678.269,0,0,1,146,650.265,550.711,550.711,0,0,1,361.171,192.232Q577.7,23.7,953.585,24.377a1885.676,1885.676,0,0,1,360.891,33.3,1669.937,1669.937,0,0,1,272.379,72.035L1485.4,583.667a2296.381,2296.381,0,0,0-221.986-62.52,1202.189,1202.189,0,0,0-268.3-27.185q-272.366,0-272.37,152.906a152.577,152.577,0,0,0,12.258,62.52,128.509,128.509,0,0,0,46.982,53.006A695.656,695.656,0,0,0,878,816.762c40.179,19.707,91.932,41.453,154.573,67.956a2376.646,2376.646,0,0,1,318,135.917,738.625,738.625,0,0,1,198.149,148.825,460.547,460.547,0,0,1,102.146,178.05,809.358,809.358,0,0,1,29.279,226.976,522.932,522.932,0,0,1-230.161,464.151q-229.474,156.979-648.928,156.981a1878.935,1878.935,0,0,1-457.593-46.891A1931.752,1931.752,0,0,1,90.84,2070.573l98.055-475.7a1930.649,1930.649,0,0,0,305.74,92.42A1479.832,1479.832,0,0,0,804.458,1720.6Z",
    transform: "translate(-108.407 -22.608)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.baeacba0ab68605a2b6d0cc08da9fb09.svg";
export { ForwardRef as ReactComponent };